export const RECEIPT_STATUS_GROUP = Object.freeze({
  ACTIVE: "active",
  PENDING: "pending",
  NEEDS_HELP: "needs_help",
  UNENROLLED: "unenrolled",
  FAILED: "failed"
})

export const RECEIPT_PAGE_STATE = {
  ACTIVE: "active",
  NOT_ENROLLED: "not_enrolled",
  PENDING: "pending"
}

export const STATUS_GROUP_META = {
  [RECEIPT_STATUS_GROUP.ACTIVE]: { label: "Active", hex: "#16895A" },
  [RECEIPT_STATUS_GROUP.PENDING]: { label: "Pending", hex: "#661AC6" },
  [RECEIPT_STATUS_GROUP.NEEDS_HELP]: { label: "Needs Help", hex: "#EB6C00" },
  [RECEIPT_STATUS_GROUP.UNENROLLED]: { label: "Unenrolled", hex: "#A1A1AA" },
  [RECEIPT_STATUS_GROUP.FAILED]: { label: "Failed", hex: "#D71313" }
}

export const PROGRAM_META = {
  all: { name: "All", iconType: null },
  cc: { name: "Consumer Clarity", iconType: "mastercard" },
  oi: { name: "Order Insight", iconType: "verifi" }
}

// Keyed by the program code the lookups API sends (`cc` / `oi`), the same way CHANNEL_META is
// keyed by the channel code. The names are the programs', not the providers' (CHA1-2501).
export const PROGRAM_CARD_META = {
  cc: { label: "Consumer Clarity", iconType: "mastercard" },
  oi: { label: "Order Insight", iconType: "verifi" }
}

export const CHANNEL_META = {
  banking_app: { label: "Banking app", color: "geekblue" },
  call_center: { label: "Call center", color: "gold" },
  mastercom: { label: "Mastercom", color: "purple" }
}
